/**
 * Trim any value and return it as a string.
 */
export function asTrimmedString(value) {
  return String(value ?? "").trim();
}

/**
 * Check whether a value is non-empty after trimming.
 */
export function isRequiredFilled(value) {
  return asTrimmedString(value).length > 0;
}

/**
 * Basic email validation for UI forms.
 * This is intentionally simple and suitable for client-side validation.
 */
export function isValidEmail(value) {
  return /\S+@\S+\.\S+/.test(asTrimmedString(value));
}

/**
 * Add a required-field error if the value is empty.
 */
export function validateRequiredField(errors, fieldName, value, message) {
  if (!isRequiredFilled(value)) {
    errors[fieldName] = message;
  }
}

/**
 * Add an email error if empty or invalid.
 * Required has priority over invalid format.
 */
export function validateEmailField(
  errors,
  fieldName,
  value,
  requiredMessage,
  emailMessage,
) {
  const trimmed = asTrimmedString(value);

  if (!trimmed) {
    errors[fieldName] = requiredMessage;
    return;
  }

  if (!isValidEmail(trimmed)) {
    errors[fieldName] = emailMessage;
  }
}
